import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {FeedbackPickEvaluatorPage} from './feedback-pick-evaluator.page';

const routes: Routes = [
  {
    path: '',
    component: FeedbackPickEvaluatorPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FeedbackPickEvaluatorPageRoutingModule {}
